// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import 'gridstack/dist/gridstack.css';
import { useNavigate, useParams } from 'react-router-dom';
import useGetDashboardDetails from '../../../../hooks/NTX/useGetDashboardDetails';
import { useTranslation } from 'react-i18next';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import { ntxAPI } from '../../../../API/axiosNeatex';
// import BuildGrid from './BuildGrid';
import Charts from '../../../Charts/Index';
import Loading from '../../../../components/Shared/Loader/Loading';
import { useDispatch } from 'react-redux';
import { GetDashboardDetails } from '../../../../store/NTX/Reports/Dashboard/dashboardSlice';
import { Card, CardBody } from '@components/card/card';
import { BuildGrid2 } from './BuildGrid2';
import { useCallback, useRef } from 'react';
// const BuilderDashboard = ({ dashboardId }) => {
//   const dispatch = useDispatch();
//   const [dateRange, setDateRange] = useState({ fromDate: '', toDate: '' });
//   const [dashboardItems, setDashboardItems] = useState([]);
//   const [itemsForUpdate, setItemsForUpdate] = useState([]);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const { t, i18n } = useTranslation();
//   // const { dashboardId } = useParams();
//   const { DashboardDetailsById: data, loading, error } = useGetDashboardDetails(dashboardId);

//   // تحديث البيانات عند تغيير التاريخ أو الحصول على البيانات
//   useEffect(() => {
//     if (data && Object.keys(data)?.length > 0) {
//       const newItems = mapDashboardItems(data.dashboardChartList);
//       setDashboardItems(newItems);
//       setItemsForUpdate(newItems);
//     }
//     // }, []);
//   }, [data, dashboardId]);

//   // تحويل البيانات إلى تخطيط الشبكة
//   const mapDashboardItems = chartList =>
//     chartList?.map(chart => ({
//       id: chart.id,
//       x: chart.xPosition,
//       y: chart.yPosition,
//       w: chart.width,
//       h: chart.height,
//       reportChartId: chart.reportChartId,
//       content: (
//         <Charts chartId={chart.reportChartId} chartDateFrom={dateRange.fromDate} chartDateTo={dateRange.toDate} />
//       )
//     }));

//   // تحديث الشبكة عند الضغط على زر الفلترة
//   const handleFilterButtonClick = async () => {
//     if (Object.keys(data)?.length > 0) {
//       setDashboardItems([]);
//       await new Promise(resolve => setTimeout(resolve, 150)); // تأخير لتحديث الشبكة
//       const updatedItems = mapDashboardItems(data.dashboardChartList);
//       setDashboardItems(updatedItems);
//     }
//   };

//   // تحديث موقع الرسوم البيانية في الشبكة
//   const handleUpdateDashboardChartPosition = async () => {
//     const request = {
//       chartList: itemsForUpdate?.map(({ id, x, y, w, h }) => ({
//         id,
//         xPosition: x,
//         yPosition: y,
//         width: w,
//         height: h
//       })),
//       dashboardId
//     };

//     try {
//       setIsSubmitting(true);
//       const { data } = await ntxAPI.post('Reports/UpdateDashboardChartPosition', request);
//       if (data?.succeeded) {
//         dispatch(GetDashboardDetails(dashboardId));
//         CustomAlert({ action: 'Edit' });
//       } else {
//         CustomAlert({ action: 'Error' });
//       }
//     } catch {
//       CustomAlert({ action: 'Error' });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <Loading loading={loading} error={error}>
//       <div>
//         <Card className='mb-4 bg-theme bg-opacity-5 border-theme'>
//           <CardBody>
//             <div className='row mb-2 align-items-center'>
//               {/* Date From */}
//               <div className='col-md-3'>
//                 <div className='input-group'>
//                   <span className='input-group-text'>من</span>
//                   <input
//                     type='date'
//                     className='form-control text-center'
//                     name='DateFrom'
//                     value={dateRange.fromDate}
//                     onChange={e => setDateRange({ ...dateRange, fromDate: e.target.value })}
//                   />
//                 </div>
//               </div>

//               {/* Date To */}
//               <div className='col-md-3'>
//                 <div className='input-group'>
//                   <span className='input-group-text'>إلى</span>
//                   <input
//                     type='date'
//                     className='form-control text-center'
//                     name='DateTo'
//                     value={dateRange.toDate}
//                     onChange={e => setDateRange({ ...dateRange, toDate: e.target.value })}
//                   />
//                 </div>
//               </div>

//               {/* Filter Button */}
//               <div className='col-md-3 text-center'>
//                 <button type='button' className='btn btn-outline-theme w-100' onClick={handleFilterButtonClick}>
//                   <i className='fas fa-filter me-2'></i>
//                   تحديث البيانات
//                 </button>
//               </div>

//               {/* Save Button */}
//               <div className='col-md-3 text-end'>
//                 <button
//                   disabled={isSubmitting}
//                   className='btn btn-theme w-50'
//                   onClick={handleUpdateDashboardChartPosition}
//                 >
//                   {isSubmitting ? (
//                     <div className='spinner-border spinner-border-sm me-2'></div>
//                   ) : (
//                     <i className='fa fa-save me-2'></i>
//                   )}
//                   {t('Save')}
//                 </button>
//               </div>
//             </div>
//           </CardBody>
//         </Card>

//         {/* عرض الشبكة إذا كانت هناك عناصر */}
//         {dashboardItems?.length > 0 && (
//           // <BuildGrid dashboardItems={dashboardItems} setItemsForUpdate={setItemsForUpdate} />

//           <BuildGrid2 dashboardItems={dashboardItems} setItemsForUpdate={setItemsForUpdate} />
//         )}
//       </div>
//     </Loading>
//   );
// };

const BuilderDashboard = ({ dashboardId }) => {
  const dispatch = useDispatch();
  const [dateRange, setDateRange] = useState({ fromDate: '', toDate: '' });
  const [presetRange, setPresetRange] = useState('custom');
  const [dashboardItems, setDashboardItems] = useState([]);
  const [itemsForUpdate, setItemsForUpdate] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isFiltering, setIsFiltering] = useState(false);
  const dashboardRef = useRef(null);
  const { t, i18n } = useTranslation();
  const { DashboardDetailsById: data, loading, error } = useGetDashboardDetails(dashboardId);

  // إعادة تعيين نطاق التاريخ حسب الخيار المحدد
  const applyDatePreset = useCallback(preset => {
    const today = new Date();
    const fromDate = new Date();

    switch (preset) {
      case 'today':
        setDateRange({
          fromDate: today.toISOString().split('T')[0],
          toDate: today.toISOString().split('T')[0]
        });
        break;
      case 'yesterday':
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        setDateRange({
          fromDate: yesterday.toISOString().split('T')[0],
          toDate: yesterday.toISOString().split('T')[0]
        });
        break;
      case 'thisWeek':
        const firstDayOfWeek = new Date(today);
        firstDayOfWeek.setDate(today.getDate() - today.getDay());
        setDateRange({
          fromDate: firstDayOfWeek.toISOString().split('T')[0],
          toDate: today.toISOString().split('T')[0]
        });
        break;
      case 'thisMonth':
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        setDateRange({
          fromDate: firstDayOfMonth.toISOString().split('T')[0],
          toDate: today.toISOString().split('T')[0]
        });
        break;
      case 'lastMonth':
        const firstDayOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const lastDayOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
        setDateRange({
          fromDate: firstDayOfLastMonth.toISOString().split('T')[0],
          toDate: lastDayOfLastMonth.toISOString().split('T')[0]
        });
        break;

      case 'nextMonth':
        const startToday = new Date(today); // من تاريخ اليوم
        const endNextMonth = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate());
        setDateRange({
          fromDate: startToday.toISOString().split('T')[0],
          toDate: endNextMonth.toISOString().split('T')[0]
        });
        break;

      case 'nextTwoMonths':
        const startToday2 = new Date(today);
        const endTwoMonths = new Date(today.getFullYear(), today.getMonth() + 2, today.getDate());
        setDateRange({
          fromDate: startToday2.toISOString().split('T')[0],
          toDate: endTwoMonths.toISOString().split('T')[0]
        });
        break;

      default:
        // لا تفعل شيئاً للخيار المخصص
        break;
    }

    setPresetRange(preset);
  }, []);

  // تحديث البيانات عند تغيير التاريخ أو الحصول على البيانات
  useEffect(() => {
    if (data && Object.keys(data)?.length > 0) {
      const newItems = mapDashboardItems(data.dashboardChartList);
      setDashboardItems(newItems);
      setItemsForUpdate(newItems);
    }
  }, [data, dashboardId]);

  // تحويل البيانات إلى تخطيط الشبكة
  const mapDashboardItems = useCallback(
    chartList =>
      chartList?.map(chart => ({
        id: chart.id,
        x: chart.xPosition,
        y: chart.yPosition,
        w: chart.width,
        h: chart.height,
        reportChartId: chart.reportChartId,
        content: (
          <Charts
            chartId={chart.reportChartId}
            chartDateFrom={dateRange.fromDate}
            chartDateTo={dateRange.toDate}
            key={chart.reportChartId}
          />
        )
      })),
    [dateRange]
  );

  // التحقق من صحة نطاق التاريخ
  const validateDateRange = useCallback(() => {
    if (dateRange.fromDate && dateRange.toDate && dateRange.fromDate > dateRange.toDate) {
      return false;
    }
    return true;
  }, [dateRange]);

  // تحديث الشبكة عند الضغط على زر الفلترة
  const handleFilterButtonClick = useCallback(async () => {
    if (!validateDateRange()) return;

    if (Object.keys(data)?.length > 0) {
      setIsFiltering(true);
      setDashboardItems([]);

      // استخدام setTimeout لمحاكاة التحميل
      await new Promise(resolve => setTimeout(resolve, 150));

      const updatedItems = mapDashboardItems(data.dashboardChartList);
      setDashboardItems(updatedItems);
      setIsFiltering(false);
    }
  }, [validateDateRange, data, mapDashboardItems]);

  // تحديث موقع الرسوم البيانية في الشبكة
  const handleUpdateDashboardChartPosition = useCallback(async () => {
    if (itemsForUpdate.length === 0) {
      return;
    }

    const request = {
      chartList: itemsForUpdate?.map(({ id, x, y, w, h }) => ({
        id,
        xPosition: x,
        yPosition: y,
        width: w,
        height: h
      })),
      dashboardId
    };

    try {
      setIsSubmitting(true);
      const { data } = await ntxAPI.post('Reports/UpdateDashboardChartPosition', request);
      if (data?.succeeded) {
        dispatch(GetDashboardDetails(dashboardId));
        window.location.reload();
      }
    } catch {
      // تمت إزالة الإشعارات
    } finally {
      setIsSubmitting(false);
    }
  }, [itemsForUpdate, dashboardId, dispatch]);

  // معالجة الضغط على مفتاح Enter في حقول التاريخ
  const handleKeyPress = useCallback(
    e => {
      if (e.key === 'Enter') {
        handleFilterButtonClick();
      }
    },
    [handleFilterButtonClick]
  );

  // تحديد ما إذا كان يجب عرض رسالة لوحة تحكم فارغة
  const showEmptyState = !loading && data?.dashboardChartList?.length === 0;

  return (
    <Loading loading={loading} error={error}>
      <div className='builder-dashboard' ref={dashboardRef}>
        <Card className='mb-4 bg-theme bg-opacity-5 border-theme shadow'>
          <CardBody className='p-3'>
            <div className='row g-2 align-items-center'>
              {/* خيارات نطاق التاريخ المسبق */}
              <div className='col-xl-4 col-lg-3 col-md-4 col-sm-6'>
                <select className='form-select' value={presetRange} onChange={e => applyDatePreset(e.target.value)}>
                  <option value='custom'>{i18n.language === 'en' ? 'Custom' : 'مخصص'}</option>
                  <option value='today'>{i18n.language === 'en' ? 'Today' : 'اليوم'}</option>
                  <option value='yesterday'>{i18n.language === 'en' ? 'Yesterday' : 'أمس'}</option>
                  <option value='thisWeek'>{i18n.language === 'en' ? 'This Week' : 'هذا الأسبوع'}</option>
                  <option value='thisMonth'>{i18n.language === 'en' ? 'This Month' : 'هذا الشهر'}</option>
                  <option value='lastMonth'>{i18n.language === 'en' ? 'Last Month' : 'الشهر الماضي'}</option>
                  <option value='nextMonth'>{i18n.language === 'en' ? 'Next Month' : 'الشهر القادم'}</option>
                  <option value='nextTwoMonths'>
                    {i18n.language === 'en' ? 'Next Two Months' : 'الشهرين القادمين'}
                  </option>
                </select>
              </div>

              {/* Date From */}
              <div className='col-xl-3 col-lg-3 col-md-4 col-sm-6'>
                <div className='input-group input-group'>
                  <span className='input-group-text'>
                    <i className='fas fa-calendar-alt me-2'></i>
                    {t('FromDate')}
                  </span>
                  <input
                    type='date'
                    className='form-control'
                    name='DateFrom'
                    value={dateRange.fromDate}
                    onChange={e => {
                      setDateRange({ ...dateRange, fromDate: e.target.value });
                      setPresetRange('custom');
                    }}
                    onKeyPress={handleKeyPress}
                  />
                </div>
              </div>

              {/* Date To */}
              <div className='col-xl-3 col-lg-3 col-md-4 col-sm-6'>
                <div className='input-group input-group'>
                  <span className='input-group-text'>
                    <i className='fas fa-calendar-alt me-2'></i>
                    {t('ToDate')}
                  </span>
                  <input
                    type='date'
                    className='form-control'
                    name='DateTo'
                    value={dateRange.toDate}
                    onChange={e => {
                      setDateRange({ ...dateRange, toDate: e.target.value });
                      setPresetRange('custom');
                    }}
                    onKeyPress={handleKeyPress}
                  />
                </div>
              </div>

              {/* Filter Button */}
              <div className='col-xl-1 col-lg-2 col-md-3 col-sm-4'>
                <button
                  type='button'
                  className='btn btn-outline-theme btn- '
                  onClick={handleFilterButtonClick}
                  disabled={isFiltering}
                  title='تحديث البيانات'
                >
                  {isFiltering ? (
                    <div className='spinner-border spinner-border-sm'></div>
                  ) : (
                    <i className='fas fa-sync-alt'></i>
                  )}
                </button>
              </div>

              <div className='col-xl-1 col-lg-2 col-md-3 col-sm-4 text-end'>
                <button
                  disabled={isSubmitting}
                  className='btn btn-theme btn- '
                  onClick={handleUpdateDashboardChartPosition}
                  title={t('Save')}
                >
                  {isSubmitting ? (
                    <div className='spinner-border spinner-border-sm'></div>
                  ) : (
                    <i className='fa fa-save'></i>
                  )}
                </button>
              </div>
            </div>
          </CardBody>
        </Card>

        {/* حالة عدم وجود مخططات */}
        {showEmptyState && (
          <Card className='text-center py-5'>
            <CardBody>
              <i className='fas fa-chart-pie fa-3x text-muted mb-3'></i>
              <h5 className='text-muted'>لا توجد مخططات في لوحة التحكم هذه</h5>
              <p className='text-muted'>اتصل بمسؤول النظام لإضافة مخططات إلى هذه اللوحة</p>
            </CardBody>
          </Card>
        )}

        {/* عرض الشبكة إذا كانت هناك عناصر */}
        {dashboardItems?.length > 0 && (
          <BuildGrid2 dashboardItems={dashboardItems} setItemsForUpdate={setItemsForUpdate} isFiltering={isFiltering} />
        )}

        {/* مؤشر التحميل أثناء التصفية */}
        {isFiltering && dashboardItems?.length > 0 && (
          <div className='dashboard-overlay'>
            <div className='spinner-border text-theme' role='status'>
              <span className='visually-hidden'>جاري التحميل...</span>
            </div>
          </div>
        )}
      </div>

      {/* إضافة بعض الأنماط الإضافية */}
      <style>
        {`
          .builder-dashboard {
            position: relative;
            transition: all 0.3s ease;
          }
          
          .dashboard-overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(255, 255, 255, 0.8);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
          }
          
          .input-group-sm > .form-control,
          .input-group-sm > .form-select,
          .input-group-sm > .input-group-text {
            padding: 0.25rem 0.5rem;
            font-size: 0.75rem;
          }
          
          .btn-sm {
            padding: 0.25rem 0.5rem;
            font-size: 0.75rem;
          }
          
          .alert {
            font-size: 0.75rem;
          }
          
          @media (max-width: 576px) {
            .col-sm-6 {
              margin-bottom: 0.5rem;
            }
          }
        `}
      </style>
    </Loading>
  );
};
export default BuilderDashboard;
